<template>
  <div class="topDiv">
    <label v-if="!noLabel" class="teams-label-font"
      >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
    >
    <b-form-input
      :disabled="computedDisabled"
      ref="inputField"
      :id="id"
      class="teams-inputField"
      :type="localType"
      :placeholder="placeholder"
      v-model.trim="inputData"
      @keydown="restrictInput"
      @input="handleInput($event)"
      @blur="$emit('handle-blur')"
      @keyup.enter="id == 'bookmark' ? $emit('handle-enter') : ''"
      :class="{
        error: showError,
        bindingClass,
      }"
    ></b-form-input>
  </div>
</template>

<script>
export default {
  name: "input",
  props: {
    bindingClass: String,
    noLabel: Boolean,
    disabled: Boolean,
    mandatory: Boolean,
    showError: Boolean,
    type: String,
    label: String,
    placeholder: String,
    id: String,
    fieldType: String,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  data() {
    return {
      inputData: "",
      decimalFields: [
        "currentCTC",
        "expectedCTC",
        "experince",
        "minSalary",
        "maxSalary",
        "experienceRequired",
      ],
      localType: "",
    };
  },
  created() {
    if (this.vmodel) {
      this.inputData = this.vmodel;
    }
    if (this.type == "email") {
      this.localType = "text";
    } else {
      this.localType = this.type;
    }
  },
  mounted() {},
  watch: {
    vmodel(newValue) {
      this.inputData = newValue;
    },
  },
  computed: {
    computedDisabled() {
      return (
        this.disabled ||
        ((this.$route.name === "EditVendor" ||
          this.$route.name === "ActivateVendor" ||
          this.$route.name === "EditVendor") &&
          this.fieldType == "default" &&
          this.type === "email") ||
        ((this.$route.name === "EditCandidate" ||
          this.$route.name === "ActivateCandidate") &&
          this.type === "email" &&
          this.id === "email")
      );
    },
  },
  methods: {
    restrictInput(event) {
      if (this.type == "number") {
        const charCode = event.key;

        // Allow Tab key to work as normal for navigation
        if (charCode === "Tab") {
          return;
        }
        if (event.ctrlKey || event.metaKey) {
          if (
            charCode === "a" ||
            charCode === "c" ||
            charCode === "v" ||
            charCode === "x"
          ) {
            return;
          }
        }
        if (/^[a-zA-Z]$/.test(charCode)) {
          // Match any alphabetic character
          event.preventDefault();
          return;
        }
        // Check if the input should allow decimals or not
        if (
          (this.id === "phoneNumber" || this.id === "altPhoneNumber") &&
          event.target.value.length >= 10 &&
          event.key !== "Backspace" &&
          event.key !== "ArrowRight" &&
          event.key !== "ArrowLeft"
        ) {
          if (
            !(
              event.ctrlKey &&
              (charCode == "a" ||
                charCode == "c" ||
                charCode == "v" ||
                charCode == "x")
            ) &&
            event.type !== "paste"
          ) {
            event.preventDefault();
            return;
          }
        }
        var allowDecimal = this.decimalFields.includes(this.id);
        if (!allowDecimal) {
          if (charCode === ".") {
            event.preventDefault();
          }
        }
        if (charCode == "+" || charCode == "-" || charCode == "e") {
          event.preventDefault();
        }
        // Replace characters based on whether decimals are allowed
        if (allowDecimal) {
          if (this.inputData) {
            let afterDecimal = this.inputData.split(".")[1];
            if (
              afterDecimal?.length >= 2 &&
              event.key !== "Backspace" &&
              !(
                event.ctrlKey &&
                (charCode == "a" || charCode == "c" || charCode == "v")
              ) &&
              event.type !== "paste"
            ) {
              event.preventDefault();
            }
          }
          // Allow digits, dot (.), but disallow 'e', '+', '-'
          this.inputData = this.inputData.replace(/[^\d.]/g, "");

          // Ensure no more than one decimal point
          this.inputData = this.inputData.replace(/(\..*)\./g, "$1");

          // Ensure no more than two digits after the decimal point
          this.inputData = this.inputData.replace(/(\.\d{2})\d+/g, "$1");
        } else {
          this.inputData = this.inputData.replace(/[^\d]/g, ""); // Only allow digits
        }

        // Remove extra decimal points
        this.inputData = this.inputData.replace(/(\..*)\./g, "$1");
        this.$forceUpdate();
        // this.handleInput();
      }
    },
    handleInput() {
      if (this.type === "email") {
        let cursor = this.$refs.inputField.selectionStart;
        this.inputData = this.inputData.toLowerCase();
        this.$nextTick(() => {
          this.$refs.inputField.setSelectionRange(cursor, cursor);
        });
      }
      this.$emit("select-value", this.inputData);
      this.$emit("handle-input");
    },
  },
};
</script>

<style scoped>
/* Hide number icon */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.topDiv > .error {
  border: 1px solid red !important;
}
</style>
